/* VORYNEX Spotlight — see blocks/vpx-spotlight.liquid.
 * Nothing heavy loads until the section is within a screen of the viewport: then three.js (dynamic import),
 * the label texture and the background loop of the active product. The frame loop runs only while something
 * moves; it stops off-screen, while the tab is hidden and when the visitor pauses motion. */

// Tub shapes. Radius of every body is 0.82 units; the outlines of Creatine and Whey were traced from the product
// photos (silhouette per row, simplified), the Pre-Workout one measured by hand.
// tour: the stops of "What's inside", in reading order — [section, u centre, v centre, width, height] as fractions
// of the unrolled label (u from its left edge, v from its top), measured on the label images.
const TUBS = {
  'pre-workout': {
    parts: [
      { mat: 'body', pts: [[0, 0], [0.74, 0], [0.80, 0.02], [0.818, 0.06], [0.82, 0.10], [0.82, 1.975], [0.80, 2.0], [0.772, 2.02], [0.768, 2.04]] },
      { mat: 'lid', pts: [[0, 2.034], [0.79, 2.034], [0.812, 2.048], [0.822, 2.08], [0.822, 2.30], [0.814, 2.336], [0.79, 2.352], [0, 2.356]] }
    ],
    seal: { r: 0.772, y: 2.03, h: 0.03 },
    sleeve: { r: 0.8235, bottom: 0.077, top: 1.979 },
    frontU: 0.17593, height: 2.356,
    tour: [['about', 0.5775, 0.2245, 0.137, 0.151], ['nutrition', 0.5785, 0.4375, 0.139, 0.235], ['use', 0.761, 0.2505, 0.144, 0.209],
      ['warnings', 0.757, 0.433, 0.136, 0.13], ['pack', 0.7295, 0.901, 0.09, 0.075]]
  },
  'creatine': {
    parts: [{ mat: 'body', pts: [[0, 0], [0.8011, 0], [0.8011, 0.0045], [0.81, 0.0134], [0.8167, 0.0467], [0.8211, 0.2292], [0.82, 1.8069], [0.8178, 1.9293], [0.8111, 1.9471], [0.7966, 1.9627], [0.7844, 1.9671], [0.7822, 1.9983], [0.8089, 2.0005], [0.8133, 2.0049], [0.8144, 2.0138], [0.81, 2.2608], [0.8011, 2.2809], [0.7833, 2.2875], [0.2848, 2.3031], [0, 2.3031]] }],
    sleeve: { r: 0.8245, bottom: 0.109, top: 1.9115 },
    frontU: 0.24995, height: 2.3031,
    tour: [['about', 0.604, 0.1535, 0.1115, 0.121], ['nutrition', 0.6305, 0.305, 0.164, 0.138], ['use', 0.8715, 0.15, 0.167, 0.114],
      ['warnings', 0.873, 0.295, 0.1695, 0.148], ['pack', 0.8325, 0.955, 0.105, 0.08]]
  },
  'whey-vanilla': {
    parts: [{ mat: 'body', pts: [[0, 0], [0.8147, 0.0011], [0.8073, 0.0159], [0.8062, 0.205], [0.8115, 0.2135], [0.8126, 0.2262], [0.8211, 2.4781], [0.8147, 2.4951], [0.8126, 2.7564], [0.8083, 2.767], [0.7998, 2.7755], [0.7637, 2.7904], [0.7563, 2.7968], [0.752, 2.8095], [0.751, 2.8414], [0.7616, 2.8541], [0.7956, 2.8626], [0.7956, 2.8796], [0.8062, 2.886], [0.8104, 2.8987], [0.8094, 3.1366], [0.8062, 3.1451], [0.7934, 3.1579], [0.7818, 3.1643], [0.7499, 3.1749], [0.7074, 3.1813], [0.4897, 3.1983], [0.188, 3.211], [0, 3.211]] }],
    sleeve: { r: 0.8245, bottom: 0.0765, top: 2.7213 },
    frontU: 0.16667, height: 3.211,
    tour: [['nutrition', 0.582, 0.1825, 0.149, 0.171], ['amino', 0.582, 0.427, 0.149, 0.226], ['use', 0.739, 0.138, 0.1175, 0.086],
      ['warnings', 0.739, 0.243, 0.1175, 0.083], ['pack', 0.714, 0.953, 0.0825, 0.06]]
  }
};
// Chocolate comes in the same tub with the same label layout (the product renders match pixel for pixel); only
// the label image differs.
TUBS['whey-chocolate'] = TUBS['whey-vanilla'];

// Per world: rim light colours and the tint of the glow behind the tub in the studio environment.
const WORLDS = {
  tropical: { rimL: 0xff7650, rimR: 0xffbf80, glow: '#ff7a5a' },
  pure: { rimL: 0x7fb4ff, rimR: 0xdcecff, glow: '#6fa8ff' },
  vanilla: { rimL: 0xffc27a, rimR: 0xfff0d2, glow: '#e8b060' },
  chocolate: { rimL: 0xffa868, rimR: 0xffdcb4, glow: '#b8743f' }
};

// Floating decor per world. d = desktop (the wide loop already frames the tub, so few pieces), n = narrow screens
// (the loop is cropped to its middle, so the decor carries the scene). Values: x%, y%, width, depth px, r0, r1, rise, period.
const DECOR = {
  tropical: [
    { k: 'passion-half', d: [35.5, 21, '7vw'], n: [7, 15, '19vw'], dp: 10, r: [-10, -4], fy: -14, t: 7.4 },
    { k: 'pineapple-chunk', d: [58.5, 17, '6.6vw'], n: [71, 10, '19vw'], dp: 13, r: [12, 18], fy: -12, t: 8.2 },
    { k: 'mango-cube', d: [60.5, 66, '3.8vw'], n: [13, 57, '9vw'], dp: 15, r: [8, -6], fy: -10, t: 6.6 },
    { k: 'papaya', n: [1, 40, '25vw'], dp: 12, r: [-22, -16], fy: -16, t: 8.8 },
    { k: 'pineapple-wedge', n: [76, 27, '29vw'], dp: 18, r: [24, 30], fy: -14, t: 8.4 },
    { k: 'monstera-blur', n: [-13, -5, '38vw'], front: true, dp: 34, r: [150, 156], fy: -18, t: 9.6 },
    { k: 'mango-half-blur', n: [70, 57, '34vw'], front: true, dp: 40, r: [-18, -12], fy: -20, t: 9.2 }
  ],
  pure: [
    { k: 'shard-long', d: [35, 19, '5.6vw'], n: [6, 13, '17vw'], dp: 10, r: [-24, -18], fy: -14, t: 7.6 },
    { k: 'rock', d: [59.5, 16, '5vw'], n: [72, 9, '17vw'], dp: 13, r: [6, 12], fy: -12, t: 8.4 },
    { k: 'rock-small', d: [61, 65, '3vw'], n: [14, 58, '8vw'], dp: 15, r: [0, -8], fy: -10, t: 6.8 },
    { k: 'puff', n: [0, 41, '22vw'], dp: 12, r: [0, 6], fy: -12, t: 9.0 },
    { k: 'shard-thin', n: [75, 30, '24vw'], dp: 18, r: [-8, -2], fy: -14, t: 8.2 },
    { k: 'cluster-blur', n: [-12, -4, '36vw'], front: true, dp: 34, r: [10, 16], fy: -18, t: 9.4 },
    { k: 'shard-long-blur', n: [72, 58, '30vw'], front: true, dp: 40, r: [-40, -34], fy: -20, t: 9.8 }
  ],
  vanilla: [
    { k: 'orchid-front', d: [34, 17, '6.6vw'], n: [5, 13, '20vw'], dp: 10, r: [-8, -2], fy: -14, t: 7.8 },
    { k: 'pod-curved', d: [59, 13, '6.6vw'], n: [70, 8, '22vw'], dp: 13, r: [0, 6], fy: -12, t: 8.6 },
    { k: 'bud', d: [61, 64, '3.4vw'], n: [14, 57, '9vw'], dp: 15, r: [-10, -4], fy: -10, t: 6.9 },
    { k: 'cream-swirl', n: [0, 42, '22vw'], dp: 12, r: [0, 4], fy: -12, t: 8.8 },
    { k: 'orchid-side', n: [75, 28, '24vw'], dp: 18, r: [10, 16], fy: -14, t: 8.4 },
    { k: 'pods-crossed-blur', n: [-12, -4, '36vw'], front: true, dp: 34, r: [20, 26], fy: -18, t: 9.6 },
    { k: 'orchid-front-blur', n: [72, 58, '30vw'], front: true, dp: 40, r: [-12, -6], fy: -20, t: 9.2 }
  ],
  // Chocolate rains down in front of the waterfall: fall = drop from above the section to below it on a loop,
  // t = seconds per fall, ph = where in its fall a piece starts (spreads them out), r = spin from start to end.
  chocolate: [
    { k: 'truffle-shaved', d: [27, 0, '3.6vw'], n: [3, 0, '14vw'], dp: 10, r: [-10, 150], t: 10.5, ph: 0.15, dx: 14, fall: true },
    { k: 'curl', d: [38, 0, '3.2vw'], n: [26, 0, '12vw'], dp: 12, r: [20, 240], t: 12.5, ph: 0.62, dx: -18, fall: true },
    { k: 'praline', d: [48, 0, '2.6vw'], n: [46, 0, '10vw'], dp: 9, r: [-5, 110], t: 13.5, ph: 0.4, dx: 10, fall: true },
    { k: 'shard', d: [60, 0, '2.8vw'], n: [63, 0, '11vw'], dp: 14, r: [-30, 160], t: 9.5, ph: 0.88, dx: -12, fall: true },
    { k: 'beans', d: [71, 0, '3.8vw'], n: [80, 0, '15vw'], dp: 12, r: [15, -140], t: 11.5, ph: 0.25, dx: 16, fall: true },
    { k: 'chunk-blur', d: [5, 0, '8vw'], n: [-9, 0, '30vw'], front: true, dp: 34, r: [-20, 120], t: 7.5, ph: 0.55, dx: 24, fall: true },
    { k: 'praline-blur', d: [89, 0, '6vw'], n: [81, 0, '22vw'], front: true, dp: 40, r: [10, -110], t: 8.5, ph: 0.05, dx: -20, fall: true }
  ]
};

const NARROW_MQ = '(max-width: 1099px), (max-aspect-ratio: 5/4)';

function init(root) {
  if (root.dataset.vpxSpotInit) return;
  root.dataset.vpxSpotInit = '1';

  const slides = [...root.querySelectorAll('[data-vpx-spot-slide]')].map(el => {
    let cfg = {};
    try { cfg = JSON.parse(el.querySelector('[data-vpx-spot-config]').textContent); } catch (e) { /* keep defaults */ }
    return { el, cfg };
  }).filter(s => TUBS[s.cfg.tub] && WORLDS[s.cfg.world]);
  if (!slides.length) return;
  // Flavours of one product (same data-group) share one stop of the carousel; each stop remembers its flavour.
  const groups = [];
  slides.forEach((s, i) => {
    const key = s.el.dataset.group || `#${i}`;
    let g = groups.find(x => x.key === key);
    if (!g) { g = { key, slides: [], current: i }; groups.push(g); }
    g.slides.push(i);
  });
  const groupOf = i => groups.findIndex(g => g.slides.includes(i));
  root.classList.toggle('has-flavours', groups.some(g => g.slides.length > 1));   // the copy carries a row of flavour buttons

  const stage = root.querySelector('[data-vpx-spot-stage]');
  let video = root.querySelector('.vpx-spot__video');
  const word = root.querySelector('.vpx-spot__word');
  const decorBack = root.querySelector('.vpx-spot__decor--back');
  const decorFront = root.querySelector('.vpx-spot__decor--front');
  const toggle = root.querySelector('[data-vpx-spot-toggle]');
  const tubImg = root.querySelector('[data-vpx-spot-tubimg]');
  let decorUrls = {};
  try { decorUrls = JSON.parse(root.querySelector('[data-vpx-spot-decor]').textContent); } catch (e) { /* no decor */ }

  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = !!(navigator.connection && navigator.connection.saveData);
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const narrowMq = matchMedia(NARROW_MQ);
  const smallScreen = Math.min(innerWidth, screen.width) < 900;

  let index = 0, isStatic = reduceMotion || saveData, inView = false, near = false, revealed = false;

  // ---------- Slides, word, nav ----------
  function setWord() {
    const w = slides[index].cfg.word || '';
    word.textContent = w;
    // Short words get bigger so they still reach past both sides of the tub.
    word.style.setProperty('--word-size', `${Math.min(34, 128 / Math.max(4, w.length)).toFixed(1)}vw`);
  }
  function applySlideDom() {
    slides.forEach((s, i) => {
      const on = i === index;
      s.el.classList.toggle('is-active', on);
      s.el.inert = !on;
      if (on) s.el.removeAttribute('aria-hidden'); else s.el.setAttribute('aria-hidden', 'true');
    });
    const cfg = slides[index].cfg;
    root.dataset.world = cfg.world;
    const still = slides[index].el.querySelector('.vpx-spot__still[data-src]');
    if (still) { still.src = still.dataset.src; still.removeAttribute('data-src'); }
    if (tubImg && cfg.poster && !root.classList.contains('has-3d')) tubImg.src = cfg.poster;
    stage.setAttribute('aria-label', (stage.dataset.labelTemplate || '[name]').replace('[name]', cfg.name || ''));
    const gi = groupOf(index);
    dots.forEach((d, i) => d.setAttribute('aria-current', i === gi ? 'true' : 'false'));
  }
  const nav = root.querySelector('[data-vpx-spot-nav]');
  const dotsWrap = root.querySelector('[data-vpx-spot-dots]');
  const dots = groups.map((g, gi) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'vpx-spot__dot';
    b.setAttribute('aria-label', (dotsWrap.dataset.template || '[name]').replace('[name]', slides[g.slides[0]].cfg.name || String(gi + 1)));
    b.addEventListener('click', () => go(g.current));
    dotsWrap.appendChild(b);
    return b;
  });
  if (groups.length > 1) nav.hidden = false;
  setWord();
  const step = d => go(groups[(groupOf(index) + d + groups.length) % groups.length].current);
  root.querySelector('[data-vpx-spot-prev]').addEventListener('click', () => step(-1));
  root.querySelector('[data-vpx-spot-next]').addEventListener('click', () => step(1));
  applySlideDom();
  root.classList.add('is-ready');

  // ---------- Background loops (a pool of video elements, one per world) ----------
  // Giving one element a new src tears its player down and builds a new one on the main thread: ~33 ms in the middle
  // of a switch (measured 2026-10-06). The neighbouring worlds' loops are now readied in their own elements ahead (when
  // the visitor reaches for the controls, and after each switch), so a switch only cross-fades two playing elements.
  const canWebm = !!video.canPlayType('video/webm; codecs="vp9"');
  const srcOf = i => (smallScreen || !canWebm ? slides[i].cfg.mp4 : slides[i].cfg.webm);
  const players = new Map();   // src → element, least recently used first
  function player(src) {
    let v = players.get(src);
    if (v) { players.delete(src); players.set(src, v); return v; }
    v = players.size ? video.cloneNode(false) : video;
    if (v !== video) { v.classList.remove('is-playing'); video.after(v); }
    v.muted = true;
    v.preload = 'auto';
    v.dataset.src = src;
    v.src = src;
    v.addEventListener('playing', () => { if (!isStatic && v === video) v.classList.add('is-playing'); });
    players.set(src, v);
    return v;
  }
  function loadVideo() {
    const want = isStatic || !near ? null : player(srcOf(index));
    players.forEach(v => { if (v !== want) { v.classList.remove('is-playing'); v.pause(); } });
    if (!want) return;
    video = want;
    if (inView) video.play().then(() => { if (video === want) want.classList.add('is-playing'); }).catch(() => {});
  }
  // The worlds next to the current one, each in an idle moment that is not mid-scroll. Elements are never emptied:
  // emptying one (src removed + load()) tore its player down on the main thread, once for 1.7 s (measured
  // 2026-10-06). A paused element costs no CPU, and there is one per world (4 today).
  function readyNeighbours() {
    if (isStatic || !near) return;
    const order = [index + 1, index - 1].map(i => (i + slides.length) % slides.length).filter(i => i !== index);
    (function next() {
      const i = order.shift();
      if (i === undefined) return;
      idleMoment().then(() => {
        if (isStatic) return;
        player(srcOf(i));
        next();
      });
    })();
  }

  // ---------- Decor ----------
  // A world's pieces downloaded and decoded ahead (when the Spotlight comes near, and the other worlds when the
  // visitor reaches for the controls): built only on arrival, they popped in one by one 0.3–0.7 s later on a phone.
  const preloaded = new Set();
  function preloadDecor(world) {
    const urls = decorUrls[world] || {}, narrow = narrowMq.matches;
    (DECOR[world] || []).forEach(it => {
      const u = urls[it.k];
      if (!u || !(narrow ? it.n : it.d) || preloaded.has(u)) return;
      preloaded.add(u);
      const im = new Image();
      im.decoding = 'async';
      im.src = u;
      if (im.decode) im.decode().catch(() => {});
    });
  }
  const decorBox = () => ({ s: root.getBoundingClientRect(), t: stage.getBoundingClientRect() });
  // box: the section and the stage, measured before a switch changes anything (see go).
  function buildDecor(animated, box = decorBox()) {
    for (const el of root.querySelectorAll('.fr')) { el.classList.add('is-leaving'); setTimeout(() => el.remove(), 420); }
    const world = slides[index].cfg.world, urls = decorUrls[world] || {};
    const narrow = narrowMq.matches;
    const { s, t } = box;
    const cx = t.left + t.width / 2 - s.left, cy = t.top + t.height * .55 - s.top;
    (DECOR[world] || []).forEach((it, i) => {
      const pos = narrow ? it.n : it.d;
      if (!pos || !urls[it.k]) return;
      const fr = document.createElement('span');
      fr.className = it.fall ? 'fr is-fall' : 'fr';
      const [x, y, w] = pos;
      // A falling piece starts part-way through its fall (ph), so the shower is already under way on arrival.
      const dl = it.fall ? -(it.ph * it.t) : -(i * 1.3 % it.t);
      fr.style.cssText = `--x:${x}%;--y:${y}%;--w:${w};--d:${it.dp};--r0:${it.r[0]}deg;--r1:${it.r[1]}deg;--fy:${it.fy}px;--t:${it.t}s;--dl:${dl.toFixed(2)}s;--st:${(i * .05).toFixed(2)}s`
        + (it.fall ? `;--dx:${it.dx || 0}px;--rest:${Math.round(22 + it.ph * 60)}vh` : '');
      // Burst from behind the tub: offset back towards the stage centre (in px, measured once per build).
      const px = x / 100 * s.width, py = y / 100 * s.height;
      fr.style.setProperty('--ex', `${Math.round((cx - px) * .8)}px`);
      fr.style.setProperty('--ey', `${Math.round((cy - py) * .8)}px`);
      const inner = document.createElement('i');
      if (!animated) inner.style.animation = 'none';
      const img = new Image();
      img.alt = ''; img.decoding = 'async'; img.src = urls[it.k];
      inner.appendChild(img); fr.appendChild(inner);
      (it.front ? decorFront : decorBack).appendChild(fr);
    });
  }

  // ---------- Motion toggle ----------
  function applyMotion() {
    root.classList.toggle('is-static', isStatic);
    toggle.setAttribute('aria-pressed', String(isStatic));
    toggle.setAttribute('aria-label', isStatic ? toggle.dataset.labelPlay : toggle.dataset.labelPause);
    loadVideo();
    wake();
  }
  toggle.addEventListener('click', () => { isStatic = !isStatic; applyMotion(); });

  // ---------- Add to cart ----------
  root.addEventListener('click', e => {
    const btn = e.target.closest('[data-vpx-spot-add]');
    if (!btn || btn.disabled) return;
    const slide = btn.closest('[data-vpx-spot-slide]');
    const status = slide.querySelector('[data-vpx-spot-status]');
    const label = btn.querySelector('[data-vpx-spot-cta-label]');
    btn.disabled = true;
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    }).then(res => { if (!res.ok) throw new Error('cart'); return res.json(); }).then(() => {
      const original = label.textContent;
      label.textContent = btn.dataset.added; btn.classList.add('is-added');
      status.textContent = status.dataset.addedMsg;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:build'));
      openMiniCart();
      setTimeout(() => { label.textContent = original; btn.classList.remove('is-added'); btn.disabled = false; status.textContent = ''; }, 2200);
    }).catch(() => { btn.disabled = false; status.textContent = status.dataset.failed; });
  });
  function openMiniCart() {
    const trigger = document.querySelector('[class*="ai-vorynex-header__cart-trigger"]');
    const panel = document.querySelector('[class*="ai-vorynex-header__cart-dropdown"]');
    if (!trigger || (panel && panel.classList.contains('active'))) return;
    const r = trigger.getBoundingClientRect();
    if (r.bottom > 0 && r.top < innerHeight) setTimeout(() => trigger.click(), 60);
  }

  // ---------- "What's inside": zoom-to-hotspot on the real label ----------
  // Overview: the tub turns to its back and numbered hotspots flank it, level with each section. A hotspot flies
  // the camera in (centred, moderate zoom, the tub still visible); that hotspot becomes ✕, which flies back out to
  // the overview. Another section means ✕ first, as with zoom-to-hotspot in a panorama viewer.
  const tourEl = root.querySelector('[data-vpx-spot-tour]');
  const tourTitle = tourEl.querySelector('[data-tour-title]');
  const tourName = tourEl.querySelector('[data-tour-name]');
  const tourNote = tourEl.querySelector('[data-tour-note]');
  const tourList = tourEl.querySelector('[data-tour-list]');
  const tourBack = tourEl.querySelector('[data-tour-back]');
  const tourClose = tourEl.querySelector('[data-tour-close]');
  const markers = root.querySelector('[data-vpx-spot-markers]');
  let tourLabels = {};
  try { tourLabels = JSON.parse(tourEl.dataset.labels || '{}'); } catch (e) { /* fall back to the keys */ }
  // Liquid's t filter HTML-escapes ("&" arrives as "&amp;"); these strings go into textContent, so decode once.
  const decoder = document.createElement('textarea');
  for (const k of Object.keys(tourLabels)) { decoder.innerHTML = tourLabels[k]; tourLabels[k] = decoder.value; }
  let touring = false, zoomed = -1;
  const stops = () => TUBS[slides[index].cfg.tub].tour;
  const sectionName = i => tourLabels[stops()[i][0]] || stops()[i][0];
  function renderTour() {
    tourName.textContent = slides[index].cfg.name || '';
    const facts = [...slides[index].el.querySelectorAll('[data-vpx-spot-facts] li')].map(li => li.textContent.replace(/\s+/g, ' ').trim());
    if (zoomed < 0) {
      tourTitle.textContent = tourLabels.choose || '';
      tourNote.textContent = '';
    } else {
      tourTitle.textContent = `${zoomed + 1} / ${stops().length} · ${sectionName(zoomed)}`;
      // The key numbers from the block settings go with the nutrition section.
      tourNote.textContent = stops()[zoomed][0] === 'nutrition' ? facts.join(' · ') : '';
    }
    tourNote.hidden = !tourNote.textContent;
    tourList.hidden = zoomed >= 0;
    tourBack.hidden = zoomed < 0;
    tourClose.hidden = zoomed >= 0;
    [...markers.children].forEach((m, i) => {
      const isClose = i === zoomed;
      m.classList.toggle('is-close', isClose);
      m.classList.toggle('is-off', zoomed >= 0 && !isClose);
      m.setAttribute('aria-label', isClose ? tourBack.textContent.trim() : `${i + 1}. ${sectionName(i)}`);
      m.tabIndex = zoomed >= 0 && !isClose ? -1 : 0;
    });
  }
  function zoomTo(i) {
    zoomed = i; renderTour();
    if (three) three.tour('zoom', i);
    tourBack.focus({ preventScroll: true });
  }
  function backToOverview() {
    const was = zoomed;
    zoomed = -1; renderTour();
    if (three) three.tour('overview');
    const btn = tourList.children[was] && tourList.children[was].querySelector('button');
    if (btn) btn.focus({ preventScroll: true });
  }
  function setTour(on, returnFocus = true) {
    if (on === touring) return;
    touring = on; zoomed = -1;
    const openBtn = slides[index].el.querySelector('[data-vpx-spot-inside]');
    if (openBtn) openBtn.setAttribute('aria-expanded', String(on));
    slides[index].el.querySelector('.vpx-spot__info').inert = on;
    if (on && arMode) setArPanel(null);
    nav.inert = on;   // faded out during the tour, so out of the tab order too
    if (arBtn) arBtn.inert = on;
    stage.tabIndex = on ? -1 : 0;   // the tour doesn't turn the tub, so the stage leaves the tab order meanwhile
    // The stage changes size: hide the canvas for the resize so the tub doesn't jump, then fly in.
    stage.classList.add('is-resizing');
    setTimeout(() => stage.classList.remove('is-resizing'), 260);
    root.classList.toggle('is-touring', on);
    document.documentElement.classList.toggle('vpx-spot-touring', on);   // floating widgets step aside (vpx-float-manager)
    tourEl.hidden = !on;
    markers.textContent = ''; tourList.textContent = '';
    if (on) {
      stops().forEach((stop, i) => {
        const m = document.createElement('button');
        m.type = 'button'; m.className = 'vpx-spot__marker'; m.dataset.n = String(i + 1);
        m.addEventListener('click', () => (zoomed === i ? backToOverview() : zoomed < 0 && zoomTo(i)));
        markers.appendChild(m);
        const li = document.createElement('li'), b = document.createElement('button');
        b.type = 'button'; b.className = 'vpx-spot__tour-item';
        b.innerHTML = `<span class="vpx-spot__tour-num">${i + 1}</span><span></span>`;
        b.lastChild.textContent = sectionName(i);
        b.addEventListener('click', () => zoomTo(i));
        li.appendChild(b); tourList.appendChild(li);
      });
      renderTour();
      if (three) three.tour('overview');
      tourList.querySelector('button').focus({ preventScroll: true });
    } else {
      if (three) three.tour('off');
      if (returnFocus && openBtn) openBtn.focus({ preventScroll: true });
    }
    wake();
  }
  root.addEventListener('click', e => { if (e.target.closest('[data-vpx-spot-inside]')) setTour(true); });
  tourBack.addEventListener('click', backToOverview);
  tourClose.addEventListener('click', () => setTour(false));
  root.addEventListener('keydown', e => {
    if (!touring || e.key !== 'Escape') return;
    e.preventDefault();
    if (zoomed >= 0) backToOverview(); else setTour(false);
  });

  // ---------- Navigation between products ----------
  function go(i) {
    if (i === index) return;
    // The decor's frame is read before anything changes: read after the changes below, it forced a style and layout
    // pass of the whole page inside the click (~15 ms on a desktop). The tour and the AR card move the stage, so
    // with either open it is read after they close.
    const box = touring || arMode ? undefined : decorBox();
    if (touring) setTour(false, false);
    if (arMode) setArPanel(null);
    index = i;
    groups[groupOf(i)].current = i;
    applySlideDom();
    word.classList.add('is-swapping');
    setTimeout(() => { setWord(); word.classList.remove('is-swapping'); }, 300);
    loadVideo();
    buildDecor(!isStatic, box);
    if (three) three.swap(index, !isStatic);
    if (wantPreload) readyNeighbours();
  }
  document.addEventListener('shopify:block:select', e => {
    const i = slides.findIndex(s => s.el.contains(e.target) || e.target.contains(s.el));
    if (i >= 0) go(i);
  });

  // ---------- AR: the tub on the visitor's table ----------
  // iPhone/iPad open the .usdz in Quick Look (its banner can add the product to the cart without leaving AR); Android
  // opens the .glb in Google's Scene Viewer. A computer can't do AR: there the button opens a card with a big QR
  // code that opens this page on the phone, on the same product, with the same card and a "View" button. While the
  // card is open the tub turns slowly all the way round, and the copy steps aside as in "What's inside".
  const arBtn = root.querySelector('[data-vpx-spot-ar]');
  const arPanel = root.querySelector('[data-vpx-spot-arpanel]');
  const probe = document.createElement('a');
  const quickLook = !!(probe.relList && probe.relList.supports && probe.relList.supports('ar'));
  const sceneViewer = !quickLook && /android/i.test(navigator.userAgent);
  const phoneAr = quickLook || sceneViewer;
  const deskAr = !!(arBtn && arPanel && !phoneAr);
  let arLink = null, arMode = null, qrLib = null;

  function launchAr() {
    const cfg = slides[index].cfg;
    if (!cfg.arGlb || !cfg.arUsdz) return;
    if (quickLook) {
      if (arLink) arLink.remove();
      arLink = document.createElement('a');
      arLink.rel = 'ar';
      const banner = cfg.arPrice ? `&callToAction=${encodeURIComponent(arBtn.dataset.cta)}&checkoutTitle=${encodeURIComponent(cfg.name || '')}`
        + `&checkoutSubtitle=${encodeURIComponent(cfg.arTitle || '')}&price=${encodeURIComponent(cfg.arPrice)}` : '';
      arLink.href = `${new URL(cfg.arUsdz, location.href).href}#allowsContentScaling=0${banner}`;
      arLink.appendChild(document.createElement('img'));   // Safari only hands rel="ar" links with an image to Quick Look
      arLink.style.cssText = 'position:fixed;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none';
      const shownSlide = index;
      arLink.addEventListener('message', e => {
        if (e.data !== '_apple_ar_quicklook_button_tapped') return;
        const add = slides[shownSlide].el.querySelector('[data-vpx-spot-add]');
        if (add && !add.disabled) add.click();
      });
      document.body.appendChild(arLink);
      arLink.click();
    } else if (sceneViewer) {
      // If the phone can't hand the model to Scene Viewer, Chrome opens the fallback: this page again, which then
      // says so instead of silently reloading.
      const glb = new URL(cfg.arGlb, location.href).href, back = new URL(location.href);
      back.searchParams.set('vpx_ar', cfg.tub); back.searchParams.set('vpx_ar_off', '1'); back.hash = '';
      location.href = `intent://arvr.google.com/scene-viewer/1.0?file=${encodeURIComponent(glb)}&mode=ar_preferred&resizable=false`
        + `&title=${encodeURIComponent(cfg.arTitle || cfg.name || '')}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;`
        + `action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(back.href)};end;`;
    }
  }

  const loadQr = () => qrLib || (qrLib = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = arBtn.dataset.qrSrc; s.onload = () => resolve(window.qrcode); s.onerror = reject;
    document.head.appendChild(s);
  }));
  async function drawQr() {
    const make = await loadQr(), cfg = slides[index].cfg, url = new URL(location.href);
    url.searchParams.set('vpx_ar', cfg.tub); url.searchParams.delete('vpx_ar_off'); url.hash = '';
    // Previewing an unpublished theme: Shopify keeps the preview in a cookie and drops it from the address, so
    // the phone needs it spelled out to open the same theme.
    const theme = window.Shopify && window.Shopify.theme;
    if (theme && theme.role && theme.role !== 'main' && theme.id) url.searchParams.set('preview_theme_id', theme.id);
    const qr = make(0, 'Q'); qr.addData(url.href); qr.make();
    const box = arPanel.querySelector('[data-vpx-spot-arqr-code]');
    box.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
    box.setAttribute('aria-label', (box.dataset.labelTemplate || '[name]').replace('[name]', cfg.arTitle || cfg.name || ''));
    box.classList.add('is-ready');
  }

  // mode: 'desk' (QR code), 'phone' (arrived from the QR code: one big button), 'off' (this phone can't do AR), null.
  function setArPanel(mode, refocus) {
    if (!arPanel) return;
    if (mode && touring) setTour(false, false);
    arMode = mode;
    arPanel.hidden = !mode;
    arPanel.dataset.mode = mode || '';
    root.dataset.arMode = mode || '';
    root.classList.toggle('is-ar', !!mode);
    document.documentElement.classList.toggle('vpx-spot-ar', !!mode);   // floating widgets step aside
    slides[index].el.querySelector('.vpx-spot__info').inert = !!mode;
    nav.inert = !!mode;
    if (arBtn) { arBtn.inert = !!mode; arBtn.setAttribute('aria-expanded', String(!!mode)); }
    stage.classList.add('is-resizing');
    setTimeout(() => stage.classList.remove('is-resizing'), 260);
    if (three) three.spin(!!mode && !isStatic);
    if (mode) {
      arPanel.querySelector('[data-ar-name]').textContent = slides[index].cfg.arTitle || slides[index].cfg.name || '';
      if (mode === 'desk') drawQr().catch(() => {});
      const first = arPanel.querySelector(mode === 'phone' ? '[data-vpx-spot-ar-go]' : '[data-vpx-spot-ar-close]');
      if (first) first.focus({ preventScroll: true });
    } else if (refocus && arBtn && !arBtn.hidden) arBtn.focus({ preventScroll: true });
    wake();
  }

  if (arBtn && arPanel && (phoneAr || deskAr)) {
    arBtn.hidden = false;
    arBtn.setAttribute('aria-controls', arPanel.id);
    arBtn.setAttribute('aria-expanded', 'false');
    // On a phone the button goes straight into AR; on a computer it opens the QR card (the library is fetched as
    // soon as the pointer heads for the button, so the code is there when the card opens).
    arBtn.addEventListener('click', () => (phoneAr ? launchAr() : setArPanel('desk')));
    if (deskAr) arBtn.addEventListener('pointerenter', () => { loadQr().catch(() => {}); }, { once: true });
    arPanel.querySelector('[data-vpx-spot-ar-go]').addEventListener('click', launchAr);
    arPanel.querySelector('[data-vpx-spot-ar-close]').addEventListener('click', () => setArPanel(null, true));
    root.addEventListener('keydown', e => { if (e.key === 'Escape' && arMode) { e.stopPropagation(); setArPanel(null, true); } });
  }


  // ---------- Flavours: switch within the product's stop (same spin as a product switch, own world and tub) ----------
  root.addEventListener('click', e => {
    const b = e.target.closest('[data-vpx-spot-flavour]');
    if (!b || b.getAttribute('aria-pressed') === 'true') return;
    const id = b.dataset.vpxSpotFlavour, i = slides.findIndex(s => s.el.dataset.block === id);
    if (i < 0) return;
    go(i);
    // The button pressed belongs to the slide that just went inert: keep focus on the same choice in the new one.
    const same = [...slides[i].el.querySelectorAll('[data-vpx-spot-flavour]')].find(x => x.dataset.vpxSpotFlavour === id);
    if (same) same.focus({ preventScroll: true });
  });

  // ---------- 3D (loaded when near) ----------
  let three = null, wakeFn = () => {};
  function wake() { wakeFn(); }
  async function loadThree() {
    try {
      const THREE = await import(root.dataset.three);
      await scrollQuiet();   // creating the WebGL stage: ~110 ms on a slow phone, never in the middle of a scroll
      const stage3d = createStage(THREE);
      await stage3d.ready;   // its programs are compiled in the background first (see createStage)
      three = stage3d;
      three.swap(index, false);
      if (wantPreload) three.preload();
      if (arMode) three.spin(!isStatic);   // the AR card opened before three.js arrived (QR code arrival)
      if (inView && !revealed) reveal();
    } catch (err) {
      root.classList.add('no-3d');   // the still backdrop and copy remain; nothing else depends on 3D
    }
  }

  function reveal() {
    revealed = true;
    buildDecor(!isStatic);
    if (three) three.intro(!isStatic);
  }
  // The other tubs' labels (and backdrops) load when the visitor reaches for the controls, so a switch never
  // shows a bare tub, and visitors who never switch never download them. Reaching for them before three.js is
  // ready still counts: the stage preloads as soon as it exists.
  let wantPreload = false;
  const warm = () => {
    if (wantPreload) return;
    wantPreload = true;
    if (three) three.preload();
    // The worlds' photos are decoded now as well: a world shown for the first time waited ~50 ms for its photo.
    slides.forEach(s => {
      const img = s.el.querySelector('.vpx-spot__still');
      if (!img) return;
      if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
      if (img.decode) img.decode().catch(() => {});
      preloadDecor(s.cfg.world);
    });
    readyNeighbours();
  };
  nav.addEventListener('pointerenter', warm, { once: true });
  nav.addEventListener('focusin', warm, { once: true });
  nav.addEventListener('touchstart', warm, { once: true, passive: true });
  // Reaching for a flavour button counts too.
  const warmOnFlavour = e => { if (e.target.closest && e.target.closest('[data-vpx-spot-flavour]')) warm(); };
  root.addEventListener('pointerover', warmOnFlavour);
  root.addEventListener('focusin', warmOnFlavour);
  root.addEventListener('touchstart', warmOnFlavour, { passive: true });

  // The Spotlight sits high on the homepage: it must not compete with the hero for the first paint, so its
  // downloads start when it comes within a screen of the viewport AND the page itself has finished loading —
  // or 5 s after it came near, so a slow third-party resource holding up the load event can't hold it up too.
  let nearing = false;
  const afterLoad = fn => {
    if (document.readyState === 'complete') return fn();
    let done = false;
    const once = () => { if (!done) { done = true; fn(); } };
    addEventListener('load', once, { once: true });
    setTimeout(once, 5000);
  };
  const begin = () => {
    if (nearing) return;
    nearing = true;
    afterLoad(() => {
      near = true;
      preloadDecor(slides[index].cfg.world);
      // The background loop downloads now too, not only once the section is in view (it then started ~0.5 s late).
      loadThree();
      loadVideo();
    });
  };
  // Within three screens (was one) the start waits only for the visitor's first move (a scroll, a touch, the mouse, a
  // key): on a phone the 3D, the loop and the pieces were still arriving 2–3 s after the visitor got there (measured
  // 2026-10-06, 4G). Without any move, as for a page left open or a speed test, it starts at one screen as before:
  // started right after load, its set-up ran in the load window and raised Lighthouse's blocking time ~1.2 → 2 s.
  let within3 = false, moved = false;
  const onMove = () => { if (moved) return; moved = true; if (within3) begin(); };
  ['scroll', 'wheel', 'touchstart', 'pointerdown', 'pointermove', 'keydown'].forEach(t => addEventListener(t, onMove, { once: true, passive: true }));
  new IntersectionObserver(([e]) => { within3 = e.isIntersecting; if (within3 && moved) begin(); }, { rootMargin: '300% 0px' }).observe(root);
  new IntersectionObserver(([e]) => { if (e.isIntersecting) begin(); }, { rootMargin: '100% 0px' }).observe(root);
  new IntersectionObserver(([e]) => {
    inView = e.isIntersecting;
    root.classList.toggle('is-away', !inView);   // pauses the decor's CSS motion off-screen
    // While the Spotlight fills the screen it has its own buttons: the page's sticky bar would cover its controls.
    document.documentElement.classList.toggle('vpx-spot-in-view', inView);
    if (inView && three && !revealed) reveal();
    if (inView) loadVideo(); else players.forEach(v => v.pause());
    wake();
  }, { threshold: 0.3 }).observe(root);
  narrowMq.addEventListener('change', () => { if (revealed) buildDecor(false); });
  // The frame loop stops while the tab is hidden; pick up where it was (a flight, the sway) on the way back.
  document.addEventListener('visibilitychange', () => { if (!document.hidden) wake(); });
  applyMotion();

  // Arriving from the QR code (?vpx_ar=<tub>): that product, in view, with the AR card open and its big "View"
  // button ready (AR itself needs a tap). vpx_ar_off: back from a phone that couldn't open it; the card says so.
  // Last in init, once everything go() touches exists.
  const arParams = new URLSearchParams(location.search), arrivedFor = arParams.get('vpx_ar');
  if (arrivedFor && arBtn && !arBtn.hidden) {
    const i = slides.findIndex(s => s.cfg.tub === arrivedFor);
    if (i >= 0) {
      go(i);
      requestAnimationFrame(() => root.scrollIntoView({ block: 'start' }));
      setArPanel(phoneAr ? (arParams.get('vpx_ar_off') ? 'off' : 'phone') : 'desk');
    }
  }

  // =====================================================================================================
  function createStage(THREE) {
    // Khronos PBR Neutral tone mapping (not in three r160): keeps the label's printed colours; ACES greyed the whites.
    THREE.ShaderChunk.tonemapping_pars_fragment = THREE.ShaderChunk.tonemapping_pars_fragment.replace(
      'vec3 CustomToneMapping( vec3 color ) { return color; }',
      `vec3 CustomToneMapping( vec3 color ) {
        const float StartCompression = 0.8 - 0.04;
        const float Desaturation = 0.15;
        color *= toneMappingExposure;
        float x = min( color.r, min( color.g, color.b ) );
        float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
        color -= offset;
        float peak = max( color.r, max( color.g, color.b ) );
        if ( peak < StartCompression ) return color;
        float d = 1. - StartCompression;
        float newPeak = 1. - d * d / ( peak + d - StartCompression );
        color *= newPeak / peak;
        float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
        return mix( color, vec3( newPeak ), g );
      }`);
    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' });
    const baseRatio = smallScreen ? 1.5 : 1.75;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, baseRatio));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.CustomToneMapping;
    renderer.toneMappingExposure = 0.95;
    stage.appendChild(renderer.domElement);

    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(24, 1, 0.1, 80);
    const pmrem = new THREE.PMREMGenerator(renderer);
    const lin = hex => { const c = new THREE.Color(hex); return [c.r, c.g, c.b]; };
    const idle = fn => (window.requestIdleCallback ? requestIdleCallback(() => fn(), { timeout: 1000 }) : setTimeout(fn, 80));

    // Half-float studio: neutral sky so white plastic stays white, a world-tinted glow behind the tub for warm or
    // cool rims, and an overhead light for the lid. No softbox strips: their reflections stayed put while the tub
    // turned and washed out letters on the label.
    // The sky (512×256, equirectangular, row 0 = straight down) is drawn by the GPU into a half-float target, with the
    // formula the CPU used to work out pixel by pixel — ~40 ms per world on a desktop, over 100 ms on a slow phone
    // (measured 2026-10-01) — then filtered by PMREM as before. Every world's light is made once the stage is up, in an
    // idle moment (see `ready`), so no product swap has to make one.
    const envCache = {};
    const skyTarget = new THREE.WebGLRenderTarget(512, 256, { type: THREE.HalfFloatType, depthBuffer: false });
    const skyColour = hex => new THREE.Vector3(...lin(hex));
    const sky = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), new THREE.ShaderMaterial({
      uniforms: { up: { value: skyColour('#ffffff') }, hor: { value: skyColour('#f4e8e0') }, down: { value: skyColour('#6a3526') }, glow: { value: new THREE.Vector3() } },
      vertexShader: 'void main() { gl_Position = vec4(position.xy, 0.0, 1.0); }',
      fragmentShader: `
        uniform vec3 up, hor, down, glow;
        float easeStep(float e0, float e1, float x) { float t = clamp((x - e0) / (e1 - e0), 0.0, 1.0); return t * t * (3.0 - 2.0 * t); }
        void main() {
          float halfTurn = 3.141592653589793;
          float el = (gl_FragCoord.y / 256.0 - 0.5) * halfTurn, az = (gl_FragCoord.x / 512.0 - 0.5) * 2.0 * halfTurn;
          vec3 c = hor + (up - hor) * (el >= 0.0 ? easeStep(0.0, 1.2, el) : 0.0);
          c += (down - c) * (el < 0.0 ? easeStep(0.0, -0.6, el) : 0.0);
          float a = az + halfTurn / 2.0, q = max(0.0, 1.0 - length(vec2(atan(sin(a), cos(a)), el - 0.1)) / 0.95);
          c += glow * (1.2 * q * q);
          float s = 2.2 * easeStep(1.05, 1.35, el);
          gl_FragColor = vec4(c + vec3(s, s * 0.98, s * 0.95), 1.0);
        }`,
      depthTest: false, depthWrite: false
    }));
    sky.frustumCulled = false;
    const skyCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    function studioEnv(glowHex) {
      if (envCache[glowHex]) return envCache[glowHex];
      sky.material.uniforms.glow.value.set(...lin(glowHex));
      const was = renderer.getRenderTarget();
      renderer.setRenderTarget(skyTarget);
      renderer.render(sky, skyCamera);
      renderer.setRenderTarget(was);
      return (envCache[glowHex] = pmrem.fromEquirectangular(skyTarget.texture).texture);
    }

    const key = new THREE.DirectionalLight(0xffffff, 1.4); key.position.set(-3, 4.2, 5); scene.add(key);
    const rimL = new THREE.DirectionalLight(0xff7650, 2.8); rimL.position.set(-4, 2.4, -3.2); scene.add(rimL);
    const rimR = new THREE.DirectionalLight(0xffbf80, 2.2); rimR.position.set(4, 2.1, -3.4); scene.add(rimR);
    const shine = new THREE.DirectionalLight(0xffffff, 0); scene.add(shine);
    // "Reading light": follows the camera during the tour so the label is evenly lit and white, like paper.
    const reading = new THREE.DirectionalLight(0xffffff, 0); scene.add(reading); scene.add(reading.target);

    // Satin plastic and a near-matte label: soft, broad highlights only, nothing that hides print.
    const MAT = {
      body: new THREE.MeshPhysicalMaterial({ color: 0xffffff, roughness: 0.45, clearcoat: 0.3, clearcoatRoughness: 0.4, envMapIntensity: 0.7 }),
      lid: new THREE.MeshPhysicalMaterial({ color: 0xffffff, roughness: 0.5, clearcoat: 0.25, clearcoatRoughness: 0.45, envMapIntensity: 0.7 }),
      seal: new THREE.MeshStandardMaterial({ color: 0xdedbd8, roughness: 0.5 })
    };
    const labels = labelUploader(THREE, renderer);
    const tubs = {};
    function buildTub(slide) {
      const cfg = slide.cfg, def = TUBS[cfg.tub];
      if (tubs[cfg.tub]) return tubs[cfg.tub];
      const group = new THREE.Group();
      for (const part of def.parts) {
        group.add(new THREE.Mesh(new THREE.LatheGeometry(part.pts.map(([r, y]) => new THREE.Vector2(r, y)), 160), MAT[part.mat]));
      }
      if (def.seal) {
        const seal = new THREE.Mesh(new THREE.CylinderGeometry(def.seal.r, def.seal.r, def.seal.h, 160, 1, true), MAT.seal);
        seal.position.y = def.seal.y; group.add(seal);
      }
      const entry = { group, def, ready: false, map: null };
      // Until its label has arrived the sleeve stays hidden (a plain tub, not a black band). The label is on the GPU
      // before the sleeve shows, so a preloaded product switches without a stall.
      const map = entry.map = labels.load(cfg.label, () => { entry.ready = true; sleeve.visible = true; wakeLoop(); });
      map.colorSpace = THREE.SRGBColorSpace; map.wrapS = THREE.RepeatWrapping; map.offset.x = def.frontU;
      map.anisotropy = 8;   // capped to what the GPU offers at upload (asking here waited ~80 ms on a busy GPU at start)
      const sl = def.sleeve;
      const sleeve = new THREE.Mesh(
        new THREE.CylinderGeometry(sl.r, sl.r, sl.top - sl.bottom, 200, 1, true),
        new THREE.MeshPhysicalMaterial({ map, roughness: 0.62, clearcoat: 0.1, clearcoatRoughness: 0.5, envMapIntensity: 0.7 })
      );
      sleeve.position.y = (sl.top + sl.bottom) / 2;
      sleeve.visible = false;
      group.add(sleeve);
      tubs[cfg.tub] = entry;
      return entry;
    }

    // Warm contact shadow; it tightens as the tub floats down.
    const sc = document.createElement('canvas'); sc.width = sc.height = 256;
    // A CPU canvas: it only becomes a texture, and drawn by the GPU its gradient made the GPU compile shaders of its own
    // while the 3D started (measured 2026-10-02).
    const sg = sc.getContext('2d', { willReadFrequently: true }), rg = sg.createRadialGradient(128, 128, 0, 128, 128, 128);
    rg.addColorStop(0, 'rgba(40,20,14,.55)'); rg.addColorStop(.42, 'rgba(40,20,14,.2)'); rg.addColorStop(1, 'rgba(40,20,14,0)');
    sg.fillStyle = rg; sg.fillRect(0, 0, 256, 256);
    const shadow = new THREE.Mesh(new THREE.PlaneGeometry(3.3, 1.35), new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(sc), transparent: true, depthWrite: false, toneMapped: false }));
    shadow.rotation.x = -Math.PI / 2; shadow.position.y = -0.005; scene.add(shadow);

    let current = null;   // { group, def, ready, map }
    const cam = { z: 8.4, lookY: 1.42, zBase: 8.4, zoom: 1 };
    // The stage's size is read when it changes (and once at the start), not on every product swap: read inside the
    // frame that swapped the product, it forced a layout of the page.
    let sized = false;
    const drawn = new THREE.Vector2();
    function frame() {
      const w = stage.clientWidth || 1, h = stage.clientHeight || 1;
      // Only a real change resizes the canvas: a resize resets its drawing buffer (and at the start it waited for the
      // busy GPU).
      if (renderer.getSize(drawn).x !== w || drawn.y !== h) renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      sized = true;
      fit();
    }
    // The camera for the current tub's height.
    function fit() {
      const aspect = camera.aspect, hgt = current ? current.def.height : 2.356;
      cam.zBase = 8.4 * (hgt / 2.356) * Math.max(1, 0.85 / aspect);
      cam.lookY = hgt * 0.603 + (cam.zBase / (hgt / 2.356) - 8.4) * 0.12;
      retarget();
      wakeLoop();
    }
    new ResizeObserver(frame).observe(stage);

    // Interaction: drag with inertia; when idle the tub sways gently around its front instead of spinning away.
    let angle = 0, velocity = 0, dragging = false, lastX = 0, lastT = 0, idleSince = performance.now(), swayStart = performance.now();
    const par = { x: 0, y: 0, tx: 0, ty: 0, sx: 0, sy: 0 };
    stage.addEventListener('pointerdown', e => {
      if (tourMode !== 'off') return;   // the tour is a guided view: hotspots, ✕ and Close move the camera
      dragging = true; lastX = e.clientX; lastT = performance.now(); velocity = 0; tween.cancel();
      stage.setPointerCapture(e.pointerId); root.classList.add('has-dragged'); wakeLoop();
    });
    stage.addEventListener('pointermove', e => {
      if (!dragging) return;
      const now = performance.now(), dx = e.clientX - lastX;
      angle += dx * 0.0105; velocity = dx * 0.0105 / Math.max(1, now - lastT) * 16.67;
      lastX = e.clientX; lastT = now; wakeLoop();
    });
    const end = () => { if (!dragging) return; dragging = false; idleSince = performance.now(); wakeLoop(); };
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    stage.addEventListener('keydown', e => {
      if ((e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') || tourMode !== 'off') return;
      e.preventDefault(); tween.cancel(); velocity = (e.key === 'ArrowLeft' ? -1 : 1) * 0.06; idleSince = performance.now(); wakeLoop();
    });
    if (finePointer) root.addEventListener('pointermove', e => { par.tx = (e.clientX / innerWidth - .5) * 2; par.ty = (e.clientY / innerHeight - .5) * 2; wakeLoop(); });

    // Tweens: reveal / product swap (spin in with a light sweep), and the spin-out before a swap.
    const tween = { kind: null, start: 0, dur: 1, p: 1, from: 0, next: null,
      cancel() { if (this.kind === 'in') { this.kind = null; this.p = 1; } } };
    function intro(animated) {
      if (!animated) { tween.kind = null; tween.p = 1; wakeLoop(); return; }
      tween.kind = 'in'; tween.start = performance.now(); tween.dur = 1600; tween.p = 0; wakeLoop();
    }
    function mount(i) {
      if (current) scene.remove(current.group);
      current = buildTub(slides[i]);
      labels.want(current.map);
      scene.add(current.group);
      const wd = WORLDS[slides[i].cfg.world];
      rimL.color.setHex(wd.rimL); rimR.color.setHex(wd.rimR);
      scene.environment = studioEnv(wd.glow);
      angle = 0; velocity = 0; swayStart = performance.now();
      if (sized) fit(); else frame();
    }
    function swap(i, animated) {
      if (!current || !animated) { mount(i); if (current && revealed) intro(false); return; }
      labels.want(buildTub(slides[i]).map);   // a label still on its way goes first
      tween.kind = 'out'; tween.start = performance.now(); tween.dur = 420; tween.p = 0; tween.from = angle; tween.next = i; wakeLoop();
    }

    const ease4 = p => 1 - Math.pow(1 - p, 4), easeIn = p => p * p * p;
    const easeInOut = p => (p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2);
    let raf = 0, lastFrame = 0, bob = 0;
    const camPos = new THREE.Vector3(0, 1.7, 8.4), camLook = new THREE.Vector3(0, 1.42, 0);
    const goalPos = new THREE.Vector3(), goalLook = new THREE.Vector3(), tmp = new THREE.Vector3();
    const TAU = Math.PI * 2;

    // "What's inside": 'off' (normal view), 'overview' (back of the tub with hotspots) or 'zoom' (one section).
    // Moves between them are timed flights with ease-in-out and a small pull-back mid-way, like Google Earth.
    let tourMode = 'off', tourIndex = -1, fly = null, tourLight = 0, spinning = false;
    const span = () => 2 * Math.tan(camera.fov * Math.PI / 360);
    function tourPose(mode, i) {
      const def = current.def, sl = def.sleeve, H = sl.top - sl.bottom;
      if (mode === 'zoom') {
        const [, u, v, w, h] = def.tour[i];
        const y = sl.bottom + (1 - v) * H, vh = span(), vw = vh * camera.aspect, wide = camera.aspect >= 1;
        // Moderate zoom, never a close-up: the section takes at most half of a wide frame (60% of a tall one) and the
        // product stays recognisable around it: the whole width of the tub on wide frames; on tall (phone) frames
        // most of its height, lid included. d is the distance from the label surface.
        const chord = 2 * sl.r * Math.sin(w * Math.PI);
        const d = Math.min((cam.zBase * 0.88 - sl.r) * 0.8, Math.max(chord / (wide ? 0.5 : 0.6) / vw, h * H / 0.55 / vh,
          wide ? 2 * sl.r * 1.5 / vw - sl.r : 2.1 / vh));
        // Sections at the very top or bottom sit off-centre rather than leave half the frame empty around the tub.
        const half = vh * d / 2, yc = half * 2 < def.height + 0.7 ? Math.min(def.height + 0.35 - half, Math.max(-0.35 + half, y)) : y;
        return { angle: -(u - def.frontU) * TAU, pos: new THREE.Vector3(0, yc + 0.12, sl.r + d), look: new THREE.Vector3(0, yc, 0) };
      }
      if (mode === 'overview') {
        // The middle of the back sections faces the camera; the whole tub is in view, centred, with room for the hotspots.
        const us = def.tour.map(s => s[1]), uMid = (Math.min(...us) + Math.max(...us)) / 2, y = def.height * 0.5;
        return { angle: -(uMid - def.frontU) * TAU, pos: new THREE.Vector3(0, y + 0.2, cam.zBase * 0.88), look: new THREE.Vector3(0, y, 0) };
      }
      return { angle: 0, pos: new THREE.Vector3(0, cam.lookY + 0.28, cam.zBase), look: new THREE.Vector3(0, cam.lookY, 0) };
    }
    function tour(mode, i = -1) {
      if (!current) return;
      // Small print needs more pixels than the showcase: render the tour at up to 2x.
      const ratio = Math.min(window.devicePixelRatio || 1, mode === 'off' ? baseRatio : 2);
      if (renderer.getPixelRatio() !== ratio) { renderer.setPixelRatio(ratio); frame(); }
      const from = { angle, pos: camPos.clone(), look: camLook.clone() }, to = tourPose(mode, i);
      to.angle += Math.round((from.angle - to.angle) / TAU) * TAU;   // the shortest way round
      const zoomingOut = tourMode === 'zoom';
      tourMode = mode; tourIndex = i; velocity = 0;
      const dist = from.pos.distanceTo(to.pos) + Math.abs(to.angle - from.angle);
      // Going in takes a little longer than coming back out.
      fly = { start: performance.now(), dur: reduceMotion ? 1 : (mode === 'zoom' ? 1400 : zoomingOut ? 1050 : 1200), from, to,
        arc: reduceMotion ? 0 : Math.min(0.8, 0.1 + dist * 0.09) };
      wakeLoop();
    }
    // After a resize the frame of every tour view changes: aim the flight (or the held view) at the new pose.
    function retarget() {
      if (tourMode === 'off' || !current) return;
      const to = tourPose(tourMode, tourIndex);
      to.angle += Math.round(((fly ? fly.to.angle : angle) - to.angle) / TAU) * TAU;
      if (fly) fly.to = to; else { camPos.copy(to.pos); camLook.copy(to.look); }
    }
    function wakeLoop() { if (!raf) raf = requestAnimationFrame(tick); }
    wakeFn = wakeLoop;
    function tick(now) {
      raf = 0;
      if (!current) return;
      const dt = lastFrame ? Math.min(64, now - lastFrame) : 16.67, f = dt / 16.67; lastFrame = now;
      let moving = dragging;
      if (tween.kind) {
        tween.p = Math.min(1, (now - tween.start) / tween.dur); moving = true;
        if (tween.kind === 'out' && tween.p >= 1) { mount(tween.next); intro(true); }
        else if (tween.p >= 1) tween.kind = null;
      }
      const touring3d = tourMode !== 'off';
      if (fly) {
        const p = Math.min(1, (now - fly.start) / fly.dur), e = easeInOut(p);
        angle = fly.from.angle + (fly.to.angle - fly.from.angle) * e;
        camPos.lerpVectors(fly.from.pos, fly.to.pos, e);
        camLook.lerpVectors(fly.from.look, fly.to.look, e);
        if (fly.arc) { tmp.subVectors(camPos, camLook).normalize(); camPos.addScaledVector(tmp, fly.arc * Math.sin(Math.PI * p)); }
        moving = true;
        if (p >= 1) { fly = null; swayStart = now; idleSince = now; }
      } else if (touring3d) {
        // Holding a tour view: the tub and the camera stay put until the next hotspot, ✕ or Close.
      } else {
        // Normal view: gentle ±20° sway around the front; after a drag it comes back the shortest way. With the AR
        // card open it turns slowly all the way round instead (a drag still takes over, then it carries on).
        const swayAmp = isStatic ? 0 : 0.35;
        const sway = swayAmp * Math.sin((now - swayStart) / 9000 * TAU);
        if (spinning && !dragging && tween.kind !== 'out') {
          angle += (0.006 + velocity) * f; velocity *= Math.pow(0.94, f);
          moving = true;
        } else if (!dragging && tween.kind !== 'out') {
          angle += velocity * f; velocity *= Math.pow(0.94, f);
          if (Math.abs(velocity) > 0.0003) moving = true;
          if (Math.abs(velocity) < 0.002 && now - idleSince > 2600) {
            const goal = sway + Math.round((angle - sway) / TAU) * TAU;
            angle += (goal - angle) * (1 - Math.pow(1 - 0.035, f));
            if (Math.abs(goal - angle) > 0.0005 || swayAmp) moving = true;
          }
        }
        goalPos.set(par.x * 0.14, cam.lookY + 0.28 - par.y * 0.06, cam.zBase); goalLook.set(0, cam.lookY, 0);
        const ck = 1 - Math.pow(1 - 0.14, f);
        camPos.lerp(goalPos, ck); camLook.lerp(goalLook, ck);
        if (camPos.distanceToSquared(goalPos) > 1e-6 || camLook.distanceToSquared(goalLook) > 1e-6) moving = true;
      }
      const bobTarget = isStatic || touring3d ? 0 : 0.035 * Math.sin(now / 5600 * TAU);
      bob += (bobTarget - bob) * (1 - Math.pow(0.9, f));
      if (!isStatic && !touring3d) moving = true;
      tourLight += ((touring3d ? 1 : 0) - tourLight) * (1 - Math.pow(0.9, f));
      if (Math.abs((touring3d ? 1 : 0) - tourLight) > 0.002) moving = true;
      const tx = isStatic || touring3d ? 0 : Math.max(-1.4, Math.min(1.4, par.tx + velocity * 9)), ty = isStatic || touring3d ? 0 : par.ty;
      const pk = 1 - Math.pow(1 - 0.075, f);
      par.x += (tx - par.x) * pk; par.y += (ty - par.y) * pk;
      if (Math.abs(tx - par.x) > 0.002 || Math.abs(ty - par.y) > 0.002) moving = true;
      if (Math.abs(par.x - par.sx) > 0.0008 || Math.abs(par.y - par.sy) > 0.0008) {
        par.sx = par.x; par.sy = par.y;
        root.style.setProperty('--px', par.x.toFixed(3)); root.style.setProperty('--py', par.y.toFixed(3));
      }
      render();
      if (moving && inView && !document.hidden) wakeLoop(); else lastFrame = 0;
    }

    function render() {
      const g = current.group;
      let spin = 0, drop = 0, scale = 1, sweep = 1;
      if (tween.kind === 'in') { const e = ease4(tween.p); spin = -1.5 * (1 - e); drop = -0.28 * (1 - e); scale = 0.94 + 0.06 * e; sweep = tween.p; }
      if (tween.kind === 'out') { const e = easeIn(tween.p); spin = 1.6 * e; drop = -0.35 * e; scale = 1 - 0.08 * e; }
      g.rotation.y = angle + spin;
      g.position.y = bob + drop;
      g.scale.setScalar(scale);
      const lift = Math.max(0, bob) - drop;
      shadow.scale.set(1 - lift * 1.6, 1, 1 - lift * 1.6); shadow.material.opacity = Math.max(0, 1 - lift * 2.2);
      // A soft sweep of light on the reveal only; the tub is satin now, so it reads as a glow, not a stripe.
      shine.intensity = tween.kind === 'in' ? 1.4 * Math.sin(Math.PI * sweep) ** 2 : 0;
      shine.position.set(-6 + 12 * sweep, 2.6, 4.5);
      key.position.set(-3 + par.x * 1.4, 4.2 - par.y * .8, 5);
      camera.position.copy(camPos);
      camera.lookAt(camLook);
      reading.intensity = 0.9 * tourLight;
      reading.position.set(camPos.x, camPos.y + 0.6, camPos.z); reading.target.position.copy(camLook);
      renderer.render(scene, camera);
      if (current.ready && !root.classList.contains('has-3d')) root.classList.add('has-3d');   // hide the still tub
      if (tourMode !== 'off') placeMarkers(g);
    }

    // Hotspots never sit on the print. In the overview they flank the tub just outside its outline, level with the
    // top of their section (left column on the left, right column on the right: the back text runs almost to the
    // outline). A zoomed section's ✕ sits in the label's margin beside it. Projected every frame.
    const mv = new THREE.Vector3(), edge = new THREE.Vector3();
    function placeMarkers(g) {
      const list = markers.children, def = current.def, sl = def.sleeve, H = sl.top - sl.bottom, r = sl.r;
      if (!list.length) return;
      g.updateMatrixWorld();
      const s = root.getBoundingClientRect(), st = stage.getBoundingClientRect();
      const toX = px => st.left - s.left + (px + 1) / 2 * st.width, toY = py => st.top - s.top + (1 - py) / 2 * st.height;
      const us = def.tour.map(t => t[1]), uMid = (Math.min(...us) + Math.max(...us)) / 2;
      // The outline of the label seen from the camera (which stays on the z axis): tangent points of the cylinder.
      const D = Math.max(r + 0.01, Math.hypot(camPos.x, camPos.z)), ex = r * Math.sqrt(1 - (r * r) / (D * D)), ez = r * r / D;
      for (let i = 0; i < list.length && i < def.tour.length; i++) {
        const [, u, v, w, h] = def.tour[i], side = u < uMid ? -1 : 1, isZoomed = tourMode === 'zoom' && i === tourIndex;
        const th = ((isZoomed ? u + side * (w / 2 + 0.045) : u) - def.frontU) * TAU;
        mv.set((r + 0.01) * Math.sin(th), sl.bottom + (1 - (v - h / 2 + 0.03)) * H, (r + 0.01) * Math.cos(th)).applyMatrix4(g.matrixWorld);
        edge.set(side * ex, mv.y, ez).project(camera);
        mv.project(camera);
        let x = isZoomed ? toX(mv.x) : toX(edge.x) + side * 28, y = toY(mv.y);
        // The ✕ stays inside the stage even when that margin is off-frame.
        if (isZoomed) { x = Math.min(st.right - s.left - 30, Math.max(st.left - s.left + 30, x)); y = Math.min(st.bottom - s.top - 30, Math.max(st.top - s.top + 30, y)); }
        list[i].style.transform = `translate(${x.toFixed(1)}px, ${y.toFixed(1)}px)`;
        list[i].classList.toggle('is-visible', !fly && (tourMode === 'overview' || isZoomed));
      }
    }

    function spin(on) {
      if (spinning === on) return;
      spinning = on;
      if (!on) idleSince = performance.now() - 2200;   // back to the front soon after
      wakeLoop();
    }

    // Every program the stage draws with is compiled in the background before its first frame: compiled at first use,
    // they froze the page ~1 s as the visitor scrolled down to the Spotlight (measured 2026-10-02 on a desktop GPU).
    // The canvas gets its size first, and the GPU is left to start the context undisturbed (gpuSettled). Then the
    // sky's and the light filter's programs; then — with the first world's light in place, which the programs depend
    // on — the tubs' materials (the first tub's, and the seal's, which only the Pre-Workout has) and the shadow. Only
    // once the GPU is done with all that do the labels go up. The other worlds' light follows in an idle moment, so no
    // product swap has to make one.
    const ready = (async () => {
      frame();
      await gpuSettled(renderer);
      await scrollQuiet();
      await lightPrograms(THREE, renderer, pmrem, sky, skyCamera, skyTarget);
      scene.environment = studioEnv(WORLDS[slides[index].cfg.world].glow);
      const first = buildTub(slides[index]).group, seal = new THREE.Mesh(new THREE.PlaneGeometry(), MAT.seal);
      await quietly(renderer, scene, camera, on => { if (on) scene.add(first, seal); else scene.remove(first, seal); });
      seal.geometry.dispose();
      await gpuSettled(renderer);
      labels.open();
      idle(() => slides.forEach(sl => studioEnv(WORLDS[sl.cfg.world].glow)));
    })();

    // The other tubs are built one per idle moment, one after the other: a tub's shapes take ~15 ms on a slow phone, and
    // all four at once held the page ~60 ms right as the visitor reached for the arrows. A switch before then builds its
    // tub on the spot.
    function preload() {
      const left = slides.slice();
      (function next() { const sl = left.shift(); if (!sl) return; buildTub(sl); if (left.length) idle(next); })();
    }
    return { ready, swap, intro, mount, tour, retarget, spin, preload: () => idle(preload) };
  }
}

// ---------------------------------------------------------------------------------------------------------------------
// Labels on the GPU without stalling the page. Uploaded straight from its image inside the image's load event, a
// 4096 px label held the main thread 130–180 ms, decoding included (measured 2026-10-01 on a desktop GPU) — right
// when the visitor reached for the arrows. Here the browser decodes it off the main thread (createImageBitmap) and it
// goes to the GPU in strips, one after each frame, each sized to take ~4 ms. No WebGL 2, or a label too big for the
// GPU: the plain image, decoded first and uploaded in an idle moment (three.js scales down what the GPU can't hold).
// load(url, ready, failed) returns the texture at once (set its wrap, offset and anisotropy then); `ready` runs when
// the whole label is on the GPU. want(texture) puts that label first in line.
function labelUploader(THREE, renderer) {
  const gl = renderer.getContext(), queue = [], wanted = new Set(), done = [], lost = [];
  let anisotropic = null;   // asked for in open(), when the GPU has nothing else to do
  // Chromium uploads a strip of rows straight from the decoded bitmap (UNPACK_SKIP_ROWS, checked pixel for pixel on
  // 2026-10-01); elsewhere each strip is cut out as a bitmap of its own first, which costs about as much again.
  // Safari's engine too (every browser on an iPhone): checked pixel for pixel in WebKit on 2026-10-06. There, cutting
  // each strip out first took ~100 ms a strip and left the tub flat for half a minute.
  const direct = !!navigator.userAgentData || (/AppleWebKit/.test(navigator.userAgent) && !/Chrom/.test(navigator.userAgent));
  const afterFrame = () => new Promise(r => requestAnimationFrame(() => setTimeout(r, 0)));
  const idle = fn => (window.requestIdleCallback ? requestIdleCallback(() => fn(), { timeout: 1000 }) : setTimeout(fn, 80));
  const mode = renderer.capabilities.isWebGL2 && typeof createImageBitmap === 'function' ? 'strips' : 'image';
  let busy = false, open;
  // Strips go up only once the stage says so (open): sent while the GPU is still compiling the stage's programs, an
  // upload waited for it (584 ms at the stack's start, measured 2026-10-02). Decoding starts at once.
  const opened = new Promise(r => { open = r; });

  async function run() {
    if (busy) return;
    busy = true;
    while (queue.length) {
      const k = queue.findIndex(j => wanted.has(j.tex)), job = queue.splice(Math.max(0, k), 1)[0];
      try {
        if (mode === 'strips') { try { await strips(job); } catch (e) { if (gl.isContextLost()) throw e; await plain(job); } }
        else await plain(job);
        done.push(job);
        job.ready();
      } catch (e) {
        if (gl.isContextLost()) lost.push(job);                                     // up again once it's back
        else job.failed(e);
      }
    }
    busy = false;
  }
  async function strips(job) {
    const res = await fetch(job.url);
    if (!res.ok) throw new Error('label HTTP ' + res.status);
    // Decoded as it is: asked for any change — flipped (as three.js stores images, bottom row first), with alpha not
    // premultiplied, or without colour management — the browser copied the whole label on the main thread when the
    // bitmap arrived: 60–120 ms a label on a slow phone, 26–40 ms on a desktop (measured 2026-10-02). Untouched, it
    // costs the main thread nothing. The labels are opaque sRGB images (no alpha, no colour profile), so there is
    // nothing to change; the texture is read upside down instead (see below), which costs nothing either.
    const bmp = await createImageBitmap(await res.blob());
    await opened;
    const W = bmp.width, H = bmp.height;
    if (Math.max(W, H) > renderer.capabilities.maxTextureSize) { bmp.close(); throw new Error('label larger than this GPU takes'); }
    const t = gl.createTexture();
    try {
      // A strip's size follows the device: about 4 ms of upload a frame (halved after a slower strip, doubled after a
      // quick one); a label someone is waiting for starts twice as big.
      let bytes = wanted.has(job.tex) ? 1 << 22 : 1 << 21;
      for (let y = 0; y < H;) {
        await afterFrame();
        if (gl.isContextLost()) throw new Error('context lost');
        const rows = Math.min(H - y, Math.max(8, Math.floor(bytes / (W * 4))));
        const strip = direct ? null : await createImageBitmap(bmp, 0, y, W, rows);
        try {
          if (gl.isContextLost()) throw new Error('context lost');
          const began = performance.now();
          renderer.state.bindTexture(gl.TEXTURE_2D, t);   // through three.js's state, so its cache stays true
          if (!y) gl.texStorage2D(gl.TEXTURE_2D, Math.floor(Math.log2(Math.max(W, H))) + 1, gl.SRGB8_ALPHA8, W, H);
          gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false); gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
          if (direct) {
            gl.pixelStorei(gl.UNPACK_SKIP_ROWS, y);
            gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, y, W, rows, gl.RGBA, gl.UNSIGNED_BYTE, bmp);
            gl.pixelStorei(gl.UNPACK_SKIP_ROWS, 0);
          } else gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, y, gl.RGBA, gl.UNSIGNED_BYTE, strip);
          const took = performance.now() - began;
          bytes = took > 4 ? Math.max(1 << 18, bytes >> 1) : took < 2 ? Math.min(1 << 22, bytes << 1) : bytes;
        } finally {
          if (strip) strip.close();
        }
        y += rows;
      }
      gl.generateMipmap(gl.TEXTURE_2D);
      // What three.js would set for this texture (sRGB storage above, as three.js picks for an sRGB label).
      const wrap = w => (w === THREE.RepeatWrapping ? gl.REPEAT : w === THREE.MirroredRepeatWrapping ? gl.MIRRORED_REPEAT : gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, wrap(job.tex.wrapS));
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, wrap(job.tex.wrapT));
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
      if (anisotropic && job.tex.anisotropy > 1) gl.texParameterf(gl.TEXTURE_2D, anisotropic.TEXTURE_MAX_ANISOTROPY_EXT, job.tex.anisotropy);   // capped by the GPU
      // The texture three.js samples is never marked for upload (version 0), so it binds this one as it is — read
      // upside down, as its first row is the label's top.
      renderer.properties.get(job.tex).__webglTexture = t;
      job.tex.repeat.y = -1; job.tex.offset.y = 1;
      job.strips = true;
    } catch (e) {
      gl.deleteTexture(t);
      throw e;
    } finally {
      bmp.close();
    }
  }
  function plain(job) {
    return new Promise((resolve, reject) => {
      new THREE.ImageLoader().load(job.url, img => {
        Promise.resolve(img.decode && img.decode()).catch(() => {}).then(() => opened).then(() => idle(() => {
          job.tex.image = img; job.tex.needsUpdate = true; renderer.initTexture(job.tex); resolve();
        }));
      }, undefined, reject);
    });
  }
  // A lost context comes back empty: three.js uploads its own textures again, the strips are ours to send.
  renderer.domElement.addEventListener('webglcontextrestored', () => {
    queue.push(...lost.splice(0), ...done.filter(j => j.strips));
    done.splice(0, done.length, ...done.filter(j => !j.strips));
    run();
  });

  return {
    load(url, ready, failed) {
      const tex = new THREE.Texture();
      queue.push({ tex, url, ready, failed: failed || (() => {}), strips: false });
      run();
      return tex;
    },
    want(tex) { if (tex) wanted.add(tex); },
    // The stage is ready: uploads may start.
    open() { anisotropic = gl.getExtension('EXT_texture_filter_anisotropic'); open(); }
  };
}

// ---------------------------------------------------------------------------------------------------------------------
// Resolves once the GPU has worked through everything sent to it so far: a fence, polled without blocking. A call that
// needs an answer from the GPU while it is still busy — starting the context, compiling — holds the page until it is
// done (80–600 ms at start, measured 2026-10-02), so the stage asks nothing of it before this.
function gpuSettled(renderer) {
  const gl = renderer.getContext();
  if (!renderer.capabilities.isWebGL2) return new Promise(r => setTimeout(r, 100));
  const sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
  if (!sync) return Promise.resolve();   // a lost context: nothing to wait for
  gl.flush();
  // At most 500 ms: Safari's engine (WebKit) reported the fence done only after ~4 s, every time (measured
  // 2026-10-06), which left the tub flat for 46 s. The wait only spares the page a stall; it must never hold the stage.
  const until = performance.now() + 500;
  return new Promise(resolve => {
    (function poll() {
      if (gl.clientWaitSync(sync, 0, 0) === gl.TIMEOUT_EXPIRED && performance.now() < until) { setTimeout(poll, 8); return; }
      gl.deleteSync(sync);
      resolve();
    })();
  });
}

// ---------------------------------------------------------------------------------------------------------------------
// Compiles everything `scene` draws without holding the page. One object's programs per task: three.js writes a
// program's shader text on the main thread, 5–15 ms each on a desktop, and all of them at once held the page 55–80 ms
// (measured 2026-10-02). They are handed to the GPU; the page waits until the GPU has worked through them (gpuSettled)
// and only then, in an idle moment, asks whether they are ready — one program per task: answering, the GPU finishes
// that program's link, ~10–20 ms each (compileAsync asks about all of them at once, and held the page ~50 ms).
// stage(on), if given, puts stand-ins in the scene while it is read.
function idleMoment() { return scrollQuiet().then(() => new Promise(r => (window.requestIdleCallback ? requestIdleCallback(r, { timeout: 1000 }) : setTimeout(r, 50)))); }

// ---------------------------------------------------------------------------------------------------------------------
// Resolves once the page has not scrolled for 160 ms. The stage's heavy steps (the WebGL context, the light, the
// programs) wait for it: run while the visitor scrolled down to the Spotlight, they froze the scroll 100–400 ms on a
// slow phone (measured 2026-10-06).
let lastScroll = -1e9;
addEventListener('scroll', () => { lastScroll = performance.now(); }, { passive: true });
function scrollQuiet() {
  return new Promise(resolve => {
    (function check() {
      const since = performance.now() - lastScroll;
      if (since < 160) setTimeout(check, 170 - since); else resolve();
    })();
  });
}
async function oneByOne(renderer, materials) {
  const gl = renderer.getContext();
  for (const m of materials) {
    const program = renderer.properties.get(m).currentProgram;
    const until = performance.now() + 400;   // same reason as gpuSettled: never wait on a late answer for long
    while (program && !program.isReady() && !gl.isContextLost() && performance.now() < until) await new Promise(r => setTimeout(r, 20));
    await new Promise(r => setTimeout(r, 0));
  }
}
async function quietly(renderer, scene, camera, stage = () => {}) {
  const objects = [], seen = new Set(), materials = new Set();
  stage(true);
  scene.traverse(o => { if (o.material && !seen.has(o.material)) { seen.add(o.material); objects.push(o); } });
  stage(false);
  for (const o of objects) {
    stage(true);
    renderer.compile(o, camera, scene).forEach(m => materials.add(m));   // lit as in the scene
    stage(false);
    await new Promise(r => setTimeout(r, 0));
  }
  await gpuSettled(renderer);
  await idleMoment();
  await oneByOne(renderer, materials);
}

// ---------------------------------------------------------------------------------------------------------------------
// The studio light's programs — the sky drawn into its half-float target, and PMREM's two filters — compiled in the
// background (resolves when they are ready). Each is compiled with the render target it is drawn into bound: that is
// part of a program's identity, and compiled for the screen (as PMREM's own warm-up does in three r160) it would be
// compiled again at first use. PMREM's blur material exists only once its targets are allocated for the size it will
// filter, so that is done here first: the cube a 512 px wide sky gets. Uses PMREMGenerator internals of the pinned
// three r160 (vpx-three.module.min.js).
function lightPrograms(THREE, renderer, pmrem, sky, skyCamera, skyTarget) {
  pmrem._setSize(skyTarget.width / 4);
  pmrem._allocateTargets().dispose();
  pmrem.compileEquirectangularShader();
  const filters = new THREE.Group();
  filters.add(new THREE.Mesh(pmrem._lodPlanes[0], pmrem._blurMaterial), new THREE.Mesh(pmrem._lodPlanes[0], pmrem._equirectMaterial));
  const flat = new THREE.OrthographicCamera(), was = renderer.getRenderTarget();
  const each = how => {
    renderer.setRenderTarget(pmrem._pingPongRenderTarget);
    const filtered = how(filters, flat);
    renderer.setRenderTarget(skyTarget);
    const drawn = how(sky, skyCamera);
    renderer.setRenderTarget(was);
    return [filtered, drawn];
  };
  // Handed to the GPU first, then asked about once it has worked through them (see quietly).
  const [filtered, drawn] = each((o, c) => renderer.compile(o, c));
  return gpuSettled(renderer).then(idleMoment).then(() => oneByOne(renderer, [...filtered, ...drawn])).catch(() => {});
}

document.querySelectorAll('[data-vpx-spotlight]').forEach(init);
document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-vpx-spotlight]').forEach(init));
